import {
    TableRow,
    TableBody,
    TableCell,
    TableContainer,
    Paper,
    Table,
    TableHead,
    Chip,
    IconButton,
    Box,
    Typography,
} from "@mui/material";
import { formatSportType } from 'src/utils/formatSportType';
import { fDateTime } from "src/utils/formatTime";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import { useNavigate } from "react-router-dom";
import Iconify from "../iconify/Iconify";

export default function TenantsTable({ tenants, onEdit, onDelete }) {
    const navigate = useNavigate();
    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="tenants table">
                <TableHead>
                    <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Sport</TableCell>
                        <TableCell>Short Code</TableCell>
                        <TableCell>Default Tenant</TableCell>
                        <TableCell>Competitions</TableCell>
                        <TableCell>Logo</TableCell>
                        <TableCell>Lobby Banner</TableCell>
                        <TableCell>Home Banner</TableCell>
                        <TableCell>Playground</TableCell>
                        <TableCell>Created At</TableCell>
                        <TableCell>Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tenants?.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={12} align="center" sx={{ py: 4 }}>
                                <Typography variant="body2" color="text.secondary">
                                    No tenants found
                                </Typography>
                            </TableCell>
                        </TableRow>
                    ) : (
                        tenants?.map((tenant, index) => (
                            <TableRow
                                key={tenant.tenantId || index}
                                sx={{
                                    "&:last-child td, &:last-child th": { border: 0 },
                                }}
                            >
                                <TableCell component="th" scope="row">
                                    {tenant.tenantId}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <strong>{tenant.name}</strong>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {formatSportType(tenant.sportType)}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {tenant.shortCode ? (
                                        <Chip
                                            label={tenant.shortCode}
                                            color="primary"
                                            size="small"
                                            variant="outlined"
                                        />
                                    ) : (
                                        <Typography variant="body2" color="text.secondary">
                                            No code
                                        </Typography>
                                    )}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {tenant.isDefaultTenant === true || tenant.isDefaultTenant === 1 ? (
                                        <Iconify
                                            icon={"eva:checkmark-circle-2-outline"}
                                            sx={{ color: "green" }}
                                        />
                                    ) : (
                                        <Iconify
                                            icon={"eva:close-circle-outline"}
                                            sx={{ color: "red" }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {tenant.competitions && tenant.competitions.length > 0 ? (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                            {tenant.competitions.map((competition) => (
                                                <Chip
                                                    key={competition.competitionId}
                                                    label={competition.competitionName}
                                                    size="small"
                                                    color="secondary"
                                                    variant="outlined"
                                                />
                                            ))}
                                        </Box>
                                    ) : (
                                        <Typography variant="body2" color="text.secondary">
                                            No competitions
                                        </Typography>
                                    )}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {tenant.logoUrl ? (
                                        <Box sx={{ width: 160, height: 80}}>
                                            <img style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={tenant.logoUrl} alt={`logo-${tenant.tenantId}`} />
                                        </Box>
                                    ) : (
                                        <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', justifyContent: 'center' }}>—</Typography>
                                    )}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {tenant.bannerImageUrl ? (
                                        <Box sx={{ width: 160, height: 80}}>
                                            <img style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={tenant.bannerImageUrl} alt={`banner-${tenant.tenantId}`} />
                                        </Box>
                                    ) : (
                                        <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', justifyContent: 'center' }}>—</Typography>
                                    )}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {tenant.homeBannerImageUrl ? (
                                        <Box sx={{ width: 160, height: 80}}>
                                            <img style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={tenant.homeBannerImageUrl} alt={`home-banner-${tenant.tenantId}`} />
                                        </Box>
                                    ) : (
                                        <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', justifyContent: 'center' }}>—</Typography>
                                    )}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {tenant.playgroundImageUrl ? (
                                        <Box sx={{ width: 160, height: 80}}>
                                            <img style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={tenant.playgroundImageUrl} alt={`playground-${tenant.tenantId}`} />
                                        </Box>
                                    ) : (
                                        <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', justifyContent: 'center' }}>—</Typography>
                                    )}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {fDateTime(new Date(tenant.createdAt))}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                        {onEdit && (
                                            <IconButton
                                                size="small"
                                                color="primary"
                                                onClick={() => onEdit(tenant)}
                                                title="Edit Tenant"
                                            >
                                                <EditIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                        <IconButton
                                            size="small"
                                            color="primary"
                                            onClick={() => navigate(`/dashboard/tenant-onboarding?tenantId=${tenant.tenantId}`)}
                                            title="Delete Tenant"
                                        >
                                            <RocketLaunchIcon fontSize="small" />
                                        </IconButton>
                                        {onDelete && (
                                            <IconButton
                                                size="small"
                                                color="error"
                                                onClick={() => onDelete(tenant)}
                                                title="Delete Tenant"
                                            >
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        )}

                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
